import { render } from "./Wallpaper.vue?vue&type=template&id=14e247bb&scoped=true"
import script from "./Wallpaper.vue?vue&type=script&lang=js"
export * from "./Wallpaper.vue?vue&type=script&lang=js"

import "./Wallpaper.vue?vue&type=style&index=0&id=14e247bb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e247bb"]])

export default __exports__